import { NavigateFunction } from 'react-router-dom';

type CustomerReturnPage = '/customers' | '/debts' | '/sales';

const getCustomerReturnPage = (state: unknown): CustomerReturnPage => {
  if (typeof state !== 'object' || state === null) return '/customers';
  const returnTo = (state as { returnTo?: unknown }).returnTo;
  return returnTo === '/debts' || returnTo === '/sales' ? returnTo : '/customers';
};

export const returnFromCustomerDetail = (navigate: NavigateFunction, state: unknown) => {
  const returnTo = getCustomerReturnPage(state);
  const companyId = typeof state === 'object' && state !== null
    && typeof (state as { companyId?: unknown }).companyId === 'string'
    ? (state as { companyId: string }).companyId
    : undefined;
  const hasKnownOrigin = typeof state === 'object' && state !== null
    && ['/customers', '/debts', '/sales'].includes((state as { returnTo?: string }).returnTo || '');
  const historyIndex = window.history.state?.idx;

  if (hasKnownOrigin && typeof historyIndex === 'number' && historyIndex > 0) {
    navigate(-1);
    return;
  }

  const returnPath = companyId
    ? `${returnTo}?companyId=${encodeURIComponent(companyId)}`
    : returnTo;
  navigate(returnPath, {
    replace: true,
    state: returnTo === '/sales' ? { showSalesHistory: true } : undefined,
  });
};
